import { render, staticRenderFns } from "./PurchasePreview.vue?vue&type=template&id=242c3e47&scoped=true&"
import script from "./PurchasePreview.vue?vue&type=script&lang=ts&"
export * from "./PurchasePreview.vue?vue&type=script&lang=ts&"
import style0 from "./PurchasePreview.vue?vue&type=style&index=0&id=242c3e47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242c3e47",
  null
  
)

export default component.exports